import { IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const AddButton = ({ tooltip, onClick, disabled = false, color = "primary" }) => (
    <Tooltip title={tooltip || ""}>
        <IconButton
            onClick={onClick}
            disabled={disabled}
            color={color} 
        >
            <AddIcon />
        </IconButton>
    </Tooltip>
);

export default AddButton;
